/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EFeedbackType } from "../types/EFeedbackType.ts";

/**
 * @description 1 = Numeric | 2 = LikeAndDislike | 3 = LikeOnly |
 */
export const eFeedbackTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Numeric | 2 = LikeAndDislike | 3 = LikeOnly | ",
  ) as unknown as ToZod<EFeedbackType>;
